import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var CustomSuggestionItem = function CustomSuggestionItem(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder;
  var wrapperClassNames = classNames('display-flex align-items-center', 'padding-top-5 padding-bottom-5', !value && 'text-color-gray');
  var iconClassNames = classNames('margin-left--5 margin-right-5 margin-top--1', 'rioglyph', !value ? 'rioglyph-arrow-up' : 'rioglyph-plus');
  return /*#__PURE__*/React.createElement("span", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement("span", {
    className: iconClassNames
  }), /*#__PURE__*/React.createElement("span", {
    className: 'text-italic'
  }, value || placeholder));
};
CustomSuggestionItem.defaultProps = {};
CustomSuggestionItem.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default CustomSuggestionItem;